import type { AnimationProps } from 'framer-motion';
import { keyframes } from 'styled-components';

import { theme } from './theme';

export const dropdownMotionConfig: AnimationProps = {
  initial: { opacity: 0, y: -16 },
  animate: { opacity: 1, y: 0 },
  transition: { type: 'spring', damping: 50, stiffness: 1000 },
};

export const slideLeft = keyframes`
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
`;

export const slideRight = keyframes`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);
  }
`;

export const overlayIn = keyframes`
  from {
    background-color: transparent;
  }
  to {
    background-color: ${theme.color.backgroundOverlay};
  }
`;

export const overlayOut = keyframes`
  from {
    background-color: ${theme.color.backgroundOverlay};
  }
  to {
    background-color: transparent;
  }
`;

export const backgroundSlide = keyframes`
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
`;
